<template lang="pug">
.casePhotoText
  .Photo-box
    Form(:model="question")
      .Photo-stem
        FormItem
          Input.input1(type='text',placeholder='标题',v-model='question.title')
        iDelModel.ide(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
        FormItem
          Input.input2(type='textarea',placeholder='正文内容',v-model='question.stem',:rows="4")
    .bigbox
      .demo-upload-list(v-for="item in question.image")
          template(v-if="item.status === 'finished'")
              img(:src="item.url")
              .demo-upload-list-cover
                  Icon(type="ios-eye-outline" @click.native="handleView(item.name)")
                  Icon(type="ios-trash-outline" @click.native="handleRemove(item)")
          template(v-else)
              Progress(v-if="item.showProgress" :percent="item.percentage" hide-info)
      Upload(
          ref="upload"
          :show-upload-list="false"
          :format="['jpg','jpeg','png']"
          :max-size="2048"
          :on-format-error="handleFormatError"
          :on-exceeded-size="handleMaxSize"
          :before-upload="handleBeforeUpload"
          multiple
          type="drag"
          action="/"
          style="display: inline-block;width:58px;")
          div(style="width: 58px;height:58px;line-height: 58px;float:left")
              Icon(type="ios-camera" size="20")
      img.img(:src='src',v-if="src!==''",style="width:58px;height:58px;float:left;margin-left:10px")
      img.img(:src="question.answer",v-if="question.answer!==''")
      Modal(title="View Image" v-model="visible")
          img(:src="question.answer" v-if="visible" style="width: 100%")
</template>

<script>
import iDelModel from "@/components/common/iDelModel";
export default {
  components: {
    iDelModel
  },
  props: ["data"],
  data() {
    return {
      file: null,
      src: "",
      imgName: "",
      type: "上传",
      visible: false,
      uploadList: [],
      question: {
        title: "",
        stem: "",
        image: this.file
      }
    };
  },
  methods: {
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove(file) {
      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "The file format is incorrect",
        desc: `File format of ${file.name} is incorrect, please select jpg or png.`
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "Exceeding file size limit",
        desc: `File  ${file.name} is too large, no more than 2M.`
      });
    },
    handleBeforeUpload(file) {
      if (["image/jpeg", "image/jpg", "image/PNG", "image/png"].indexOf(file.type) === -1) {
        this.$Message.error("请上传正确的图片格式");
        return false;
      }
      const that = this;
      this.file = file;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        that.src = reader.result;
      };

      return false;
    },
    // 删除
    delModel() {
      this.$emit("delModel");
    }
  },
  mounted() {
    this.uploadList = this.$refs.upload.fileList;
    this.$nextTick(() => {
      if (Object.keys(this.data).length !== 0) {
        this.question = this.data;
      }
      //   this.$emit("data1:data", this.question);
    });
  },
  watch: {
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
<style lang="stylus">
.casePhotoText
  .Photo-box
    padding 24px
    width 100%
    margin 0 auto
    .bigbox
      display inline-block
      div
        float left
      .img
        // display block
        width 58px
        height 58px
        margin-left 10px
      .demo-upload-list
        display inline-block
        width 60px
        height 60px
        text-align center
        line-height 60px
        border 1px solid transparent
        border-radius 4px
        overflow hidden
        background #fff
        position relative
        box-shadow 0 1px 1px rgba(0, 0, 0, 0.2)
        margin-right 4px
        img
          width 100%
          height 100%
        .demo-upload-list-cover
          display none
          position absolute
          top 0
          bottom 0
          left 0
          right 0
          background rgba(0, 0, 0, 0.6)
          i
            color #fff
            font-size 20px
            cursor pointer
            margin 0 2px
      .demo-upload-list:hover .demo-upload-list-cover
        display block
    .Photo-stem
      position relative
      .ide
        margin-top -10px
      .input1
        width 80%
        float left
      .ivu-form-item-content
        // margin-right 300px
      .btns
        position absolute
        top -5px
        right 0px
        .ivu-icon
          color #3A76D2FF
          font-size 22px
          top 0
          margin-right 12px
          background #F2F5FAFF
          width 24px
          height 24px
          border-radius 4px
          text-align center
          line-height @height
          &:hover
            cursor pointer
</style>
